const BASE_ROUTE = '/home';

export enum Routes {
  Assignments = `${BASE_ROUTE}/assignments`,
  Base = BASE_ROUTE,
  IndependentPractice = `${BASE_ROUTE}/independent-practice`,
  SkillPath = `${BASE_ROUTE}/skill-path`,
  Welcome = `${BASE_ROUTE}/welcome`
}
